/* Panels/UserDashboard/Pages/ProfileSuite/components/BackBtn.jsx */
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { motion, easeOut } from "framer-motion";

export default function BackBtn() {
  const nav = useNavigate();
  return (
    <motion.div initial={{y:-10,opacity:0}} animate={{y:0,opacity:1}}>
      <IconButton onClick={() => nav(-1)} style={{marginBottom:24}}>
        <ArrowBackIosNewIcon sx={{ color:"#37474F" }} />
      </IconButton>
    </motion.div>
  );
}
